/**
 * Derives the active subeventId from subeventMeta based on the current time.
 * If now >= startTime, the event is in-play and the inPlaySubeventId is returned.
 * Otherwise, the preMatchSubeventId is returned.
 *
 * Extracted to @cx-web/utils for atlas-astro (NGF-6506 SUBEVENT_HEADER component-map
 * load). RR7 atlas's local copy at apps/atlas/app/routes/$/utils/getSubeventId.ts
 * was replaced with a re-export from this shared version in the same commit.
 */
export const getSubeventId = (subeventMeta: {
  inPlaySubeventId: number;
  preMatchSubeventId: number;
  startTime: string;
}): number => {
  const currentDatetime = new Date();
  const isInPlay = currentDatetime >= new Date(subeventMeta.startTime);
  return isInPlay ? subeventMeta.inPlaySubeventId : subeventMeta.preMatchSubeventId;
};
